import { createFeature, createReducer } from '@ngrx/store';

import { bookEventDialogReducers } from './timeline-book-event.reducer';
import { timelineBookEventInitialState } from './timeline-book-event.state';

export const timelineBookEventFeature = createFeature({
  name: 'jobV3TimelineBookEvent',
  reducer: createReducer(timelineBookEventInitialState, ...bookEventDialogReducers),
});
